import React from 'react';
import ReactTable from "react-table";
import { isEqual, get, find } from 'lodash';
import { connect } from 'react-redux';
import cellHeaderHOC from '../../common/Datagrid/CellHeaderHOC';
import { topTracksSettings } from './TopTracks/Settings'
const CellHeaderTable = cellHeaderHOC(ReactTable);
import { spotifyDiscoveryActions } from '../../../data/actions/spotify_discovery';
import Box from '../../common/Box';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChartWithAnnotations';
import ReactSelect from '../../common/ReactSelect';
import CSV from '../../../helpers/CSVExport';
import ModeSelect from '../../common/ModeSelect';

const lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
const tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');
const barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
const downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');

class TopTracks extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			mode: props.defaultMode || 'table',
			metric: 'Collection'
		};
		this.getData = this.getData.bind(this);
		this.setMode = this.setMode.bind(this);
		this.setMetric = this.setMetric.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
	}
	
	getData(params, useCache){
		const { mode } = this.state;
		if(mode == 'table') {
			this.props.dispatch(
				spotifyDiscoveryActions.getSpotifyDiscovery(params, useCache)
			)
		}
		else {
			this.props.dispatch(
				spotifyDiscoveryActions.getSpotifyDiscoveryMainTimeseries(params, useCache)
			)
		}
	
	}
	
	componentDidMount(){
		this.getData(this.props.params);
	}
	
	componentWillReceiveProps(nextProps){
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined && !isEqual(nextProps.filter.global, this.props.filter.global)) {
				this.getData(nextProps.params, false);
			}                
		}

		if(nextProps.params){
			if(this.props.params!==undefined && !isEqual(nextProps.params, this.props.params)) {
				this.getData(nextProps.params, false);
			}                
		}
	}

	setMode(mode){
		const { mode: prevMode } = this.state;
		const newModeIsTable = mode === 'table';
		const prevModeWasTable = prevMode === 'table';
		
		this.setState({mode}, ()=>{
			if((prevModeWasTable && !newModeIsTable) || (!prevModeWasTable && newModeIsTable))
				this.getData(this.props);
		});
	
		const { modeChange } = this.props;
		if(typeof modeChange == 'function')
			modeChange(mode);
	}
	
	setMetric(metric){
		this.setState({
			metric: metric.value
		})
	}
	
	exportToCsv(){
		const { data = [] } = this.props.spotifyDiscovery;
		const filename = CSV.CSVHeader('Spotify Discovery', 'Top Tracks');
		return CSV.CSVExport(data, {filename}, 'spotify_discovery_top_tracks');
	}

	renderToolbar(){
		let toolbar = [];
		const options = [
			{icon: tableSvg, value: 'table', label: "Table"},
			{icon: barSvg, value: 'bar', label: "Bar Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"}
		];
		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
		<div className="ibox-icon-holder mode-select">
			<ModeSelect options={options} selected={this.state.mode} onChange={this.setMode} isSearchable={ false } />
		</div>
		<div className="ibox-actions">
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />	
		</div>
		</div>)
		return toolbar;
	}
	
	getTitle(){
		const { global } = this.props.filter;
		
		return `Top Discovery Mode Tracks (${get(global, 'limit', '10')})`;
		
	}
	
	renderChartActions(data, contentTypes = []){
		const { metric, mode } = this.state;
		if(mode == 'table')
			return null;
			
		const metrics = [{
			label: 'Collection', value: 'Collection',
		},{
			label: 'Radio', value: 'Radio',
		}];
		const metricValue = find(metrics, m=>m.value == metric);
		return <React.Fragment>			
			<div className="entity-selector-select">
				<ReactSelect options={metrics} value={metricValue} onChange={this.setMetric}  className="single-select " />
			</div>
		</React.Fragment>
	}

	

	render () {
		const { data = [], loading, details, loadingDetails } = this.props.spotifyDiscovery;
		const { mode, metric } = this.state;
		
		return <Box title={this.getTitle()} toolbar={this.renderToolbar()} spinnerEnabled={(loading || loadingDetails)}
		chartActions={this.renderChartActions()} >
			{(mode == 'table' && data.length > 0) && <CellHeaderTable 
				resizable={false}
				defaultPageSize={data ? data.length:10}
				data={data} 
				className={"new-releases-track top-tracks-in-playlist simple-table"} 
				columns={topTracksSettings.settingsForTable()}
				noDataText='No results found. Please check your filters.'
				showPagination={false}
			/>}
			{(mode != 'table' && details) && <div className="chart-block">
				{mode == 'line' && <LineChart data={details[metric]} shadowChart={true} shadowChartWidth={800} shadowChartHeight={300} id={'spotify_monetization_top_tracks'}  period={this.props.period} dateGroup={this.props.period} filteredLogVendors={['spotify']} />}
				{mode == 'bar' && <StackedBarChart data={details[metric]} shadowChart={true} shadowChartWidth={800} shadowChartHeight={300} id={'spotify_monetization_top_tracks'} filteredLogVendors={['spotify']} />}
			</div>}
		</Box>
	}
	
}


function mapStateToProps(state) {
	return {
		filter: state.filter,
		milestones: state.milestones,
		spotifyDiscovery: state.spotifyDiscovery 
	} 
}
export default connect(mapStateToProps)(TopTracks);